import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const DealershipsPage = lazyRouteComponent(() => import("@modules/dealerships/pages/DealershipsPage"), "DealershipsPage");

export function getRoutes(parentRoute) {
  return [createRoute({ getParentRoute: () => parentRoute, path: "/dealerships", component: DealershipsPage })];
}
